import DeleteModalContext  from './delete-modal-context'
import {useState,useEffect} from 'react'
export interface iDeleteModal {
    open:boolean,remove:Function,message:string,
    drawer_parent?:boolean
}
const DeleteModalProvider =(props:any)=>{
 
    const [openDeleteModal,setOpenDeleteModal]=useState<iDeleteModal>({open:false,
        remove:function(){},message:''})

   
   

    return (
        <DeleteModalContext.Provider
        value={
            {
               
         openDeleteModal,
         setOpenDeleteModal
        }
        }>
            {props.children}
        </DeleteModalContext.Provider>
    )
}
export default DeleteModalProvider;